import React from 'react';
import { ListGroup, ListGroupItem } from 'reactstrap';

const OrientationCardBody = (props) => {
  return (
    <ListGroup className="list-group-flush">
      <ListGroupItem>
        <span>Status:</span>
        <span>{props.phase.getCapitalized('status')}</span>
      </ListGroupItem>
    </ListGroup>
  );
};

export default OrientationCardBody;
